<button type="button" class="expand-btn"
        [disabled]="disabled"
        (click)="expandClick.emit($event)"
        [attr.aria-expanded]="expanded">
  {{ (expanded ? 'tarificateur.hide_details' : 'tarificateur.show_details') | translate }}
  <mat-icon>{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
</button>
